import { Button, useToast } from '@chakra-ui/react';
import { Quote } from '@pelicargo/types';
import { copyText, makeBasicTable } from '@pelicargo/ui';
import { prettyCurrency } from '@pelicargo/utils';
import { useCallback, useMemo } from 'react';
import { HiClipboardCopy } from 'react-icons/hi';

import { QuoteVariantWithLineItemsPossibleInland, useQuoteVariantHelper } from '../hooks/useQuoteVariantHelper';

type Props = {
  quote: Quote;
  quoteVariant: QuoteVariantWithLineItemsPossibleInland;
};

export const CopyLineItemsButton = ({ quote, quoteVariant }: Props) => {
  const toast = useToast();

  const combinedLineItems = useMemo(() => {
    return [...(quoteVariant?.line_items || []), ...(quoteVariant?.inland_service_quote_variant?.line_items || [])];
  }, [quoteVariant]);

  const { allInVariableRate, totalCost } = useQuoteVariantHelper(quoteVariant, quote);
  const copyLineItems = useCallback(() => {
    const lines = combinedLineItems.map((li) => {
      return [
        li.label,
        li.per_unit_cost_type === 'CURRENCY' && li.is_per_unit ? `${prettyCurrency(li.per_unit_cost)}/kg` : '',
        prettyCurrency(li.cost),
      ];
    });
    lines.push(['', '', '']);
    lines.push(['Total', `${prettyCurrency(allInVariableRate)}/kg`, prettyCurrency(totalCost)]);

    const padded = makeBasicTable(lines);

    copyText(padded);
    toast({
      colorScheme: 'green',
      title: 'Copied!',
      duration: 1000,
    });
  }, [combinedLineItems, allInVariableRate, totalCost, toast]);

  return (
    <Button
      onClick={copyLineItems}
      leftIcon={<HiClipboardCopy />}
      variant="ghost"
      size="xs"
      opacity={0}
      _groupHover={{ opacity: 1 }}
    >
      Copy
    </Button>
  );
};
